import template from './simulator.html'
import css from './simulator.css'
import { SimulatorController } from './simulator.controller.js'

export const SimulatorComponent = {
  template: template,
  controller: SimulatorController,
  controllerAs: 'SimulatorController'
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/simulator.component.js